import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
// import ReactWeeklyDayPicker from 'react-weekly-day-picker'
import { Query, Mutation } from 'react-apollo'
import {
  Loading, Div, P, Icon, Label,
} from 'konsys-ui'
import client from '../../apollo-client'
import { ServiceCategory } from './service-categories'
import {
  Template, RadioGroup, TextWithIcon,
} from './utils'
import {
  GET_SHOPS, GET_BARBERS, GET_APPOINMENT, GET_SERVICES, GET_ME,
} from '../../constants/graphql/query'
import {
  CREATE_APPOINTMENT,
} from '../../constants/graphql/mutation'
import { theme } from '../../styles/_variables'
import { getAccessToken } from '../../utils/local-data-service'
import {
  TimeLabel, TimeWrapper, TimeListWrapper, RadioInput, DividerConfirm,
  ConfirmDataSpaceBetweenWrapper, BarberImg, BookingStatusWrapper,
  StatusWrapper, StatusIcon, StatusText, TimeError, DisabledTimeWrapper,
  ErrorIspreferenceMessage,
} from './styled'
import { StepLogin } from '../login'
import history from '../../history'
import Logo from '../../images/banner.jpg'
import { getShopContact } from '../../constants/shop-contacts'

const parseNotWorkingTodayMessage = (message) => {
  if (!message || typeof message !== 'string') return null
  if (message === 'notworkingtoday' || message === 'notworkingtoday:off') {
    return { type: 'off' }
  }
  if (message.indexOf('notworkingtoday:at:') === 0) {
    const rest = message.slice('notworkingtoday:at:'.length)
    const colon = rest.indexOf(':')
    if (colon === -1) return { type: 'off' }
    const shopId = rest.slice(0, colon)
    const shopname = rest.slice(colon + 1)
    return { type: 'at', shopId, shopname }
  }
  return null
}

const SelectedShopContactLine = ({ shopId }) => {
  const contact = getShopContact(shopId)
  if (!contact) return null
  if (contact.displayPhone && contact.tel) {
    return (
      <P margin='8px 0 0' light={true} color={theme.color.heather}>
        Please contact {contact.name}:{' '}
        <a href={`tel:${contact.tel}`}>{contact.displayPhone}</a>
      </P>
    )
  }
  return (
    <P margin='8px 0 0' light={true} color={theme.color.heather}>
      Please contact {contact.name} branch for assistance.
    </P>
  )
}

const noPreference = {
  id: 1000000,
  text: 'No Preference',
  label: 'Choose any barbers',
  img: Logo,
}

const stepSelector = (
  step, location, setLocation, setStep,
  setServices, services,
  staff, setStaff,
  additionalServices, setAdditionalServices,
  selectedDate, setSelectedDate,
  selectedTime, setSelectedTime,
  registerData, setRegisterData,
) => {
  const [isCreateAppointmentSuccess, setIsCreateAppointmentSuccess] = useState(false)
  const [isShowPreference, setIsShowPreference] = useState(false)
  switch (step) {
    case 1:
      return <Step1
        location={location}
        setLocation={val => setLocation(val)}
        nextStep={() => setStep(step + 1)}
        setServices={setServices}
      />
    case 2:
      return <Step2
        nextStep={() => setStep(step + 1)}
        backStep={() => setStep(step - 1)}
        setServices={val => setServices(val)}
        services={services}
        location={location}
      />
    case 3:
      return <Step4
        nextStep={() => setStep(step + 1)}
        backStep={() => { setStaff(null); setStep(step - 1) }}
        setStaff={val => setStaff(val)}
        staff={staff}
        filterData={{
          shopId: location.value,
          serviceId: _.filter(services, v => v.checked !== null).length > 0 ? _.filter(services, v => v.checked !== null).map(v => v.checked) : [],
        }}
      />
    case 4:
      return <Step5
        nextStep={() => setStep(step + 1)}
        backStep={() => { setSelectedDate(moment.tz('Asia/Bangkok').format('DD MMM YYYY')); setSelectedTime(null); setStep(step - 1) }}
        filterData={{
          shopId: location && location.value,
          serviceId: _.filter(services, v => v.checked !== null).length > 0 ? _.filter(services, v => v.checked !== null).map(v => v.checked) : [],
          staff: staff && staff.value,
        }}
        selectedDate={selectedDate}
        setSelectedDate={val => setSelectedDate(val)}
        selectedTime={selectedTime}
        setSelectedTime={val => setSelectedTime(val)}
        isShowPreference={isShowPreference}
        setIsShowPreference={val => setIsShowPreference(val)}
      />
    case 5:
      if (getAccessToken()) {
        setStep(step + 1)
      }
      return <StepLogin
        nextStep={6}
        filterData={{
          shop: location,
          serviceDetail: services,
          staff,
          selectedDate,
          selectedTime,
        }}
      />
    case 6:
      return <Step7
        registerData={registerData}
        filterData={{
          shop: location,
          serviceDetail: _.filter(services, v => v.checked !== null).length > 0 && _.filter(services, v => v.checked !== null),
          staff,
          selectedDate,
          selectedTime,
        }}
        onCreateAppointment={({ success }) => {
          setIsCreateAppointmentSuccess(success)
          setStep(step + 1)
        }}
        backStep={() => setStep(step - 2)}
      />
    case 7:
      return <Step8
        nextStep={() => history.push('/profile#booking-detail')}
        backStep={() => setStep(step - 6)}
        status={isCreateAppointmentSuccess}
      />
    default:
      return <Step1
        location={location}
        setLocation={val => setLocation(val)}
        nextStep={() => setStep(step + 1)}
        setServices={setServices}
      />
  }
}

const Step1 = ({
  location, setLocation, nextStep, setServices,
}) => (
  <Template
    title='Select Location'
    buttonProps={{
      next: {
        text: 'Next to select services',
        onClick: () => {
          setServices([
            {
              id: 1,
              checked: null,
            }, {
              id: 2,
              checked: null,
            }, {
              id: 3,
              checked: null,
            }, {
              id: 4,
              checked: null,
            }, {
              id: 5,
              checked: null,
            }, {
              id: 6,
              checked: null,
            },
          ])
          return nextStep()
        },
        disabled: location === null,
      },
    }}
  >
    <Query
      query={GET_SHOPS}
      client={client}
    >
    {
      ({ loading, data, error }) => {
        if (error) return <TextWithIcon icon='fal fa-bomb' text='Something went wrong' />
        if (loading || !data) return <Loading width='100%' center={true} />
        const radioList = data.shops.lists.length > 0 && data.shops.lists.map(v => (
          {
            radioId: v.shopname,
            text: v.shopname,
            label: v.phonenumber,
            value: v.id,
            checked: location && parseInt(location.value, 10) === v.id,
          }
        ))
        return (
          <RadioGroup
            radioName='location'
            value={radioList}
            onChange={(value) => {
              const selectedList = _.filter(radioList, v => v.value === parseInt(value, 10))
              if (selectedList.length > 0) {
                setLocation(selectedList[0])
              }
            }}
          />
        )
      }
    }
    </Query>
  </Template>
)

const Step2 = ({
  nextStep, backStep, services, setServices, location,
}) => (
    <Template
      title='Select Services'
      reset={true}
      resetFunction={() => setServices([
        {
          id: 1,
          checked: null,
        }, {
          id: 2,
          checked: null,
        }, {
          id: 3,
          checked: null,
        }, {
          id: 4,
          checked: null,
        }, {
          id: 5,
          checked: null,
        }, {
          id: 6,
          checked: null,
        },
      ])}
      buttonProps={{
        next: {
          text: 'Next to select staff',
          onClick: () => nextStep(),
          disabled: _.isEmpty(_.filter(services, o => !_.isNull(o.checked))),
        },
        back: {
          text: 'Go back',
          onClick: () => backStep(),
        },
      }}
    >
      <Query
        query={GET_SERVICES}
        variables={{
          shopId: parseInt(location.value, 10),
        }}
        fetchPolicy='network-only'
      >{({ data, loading, error }) => {
        if (error) return <TextWithIcon icon='fal fa-bomb' text='Something went wrong' />
        if (loading || !data) return <Loading width='100%' center={true} />
        if (data.serviceTypes.lists && data.serviceTypes.lists.length === 0) return <TextWithIcon icon='fal fa-bomb' text='No Services avaliable in this shop' />
        return data.serviceTypes.lists.map((v, index) => (
          <ServiceCategory
            margin={index === 0 ? '0 0 32px' : '32px 0'}
            data={v}
            key={v.id}
            services={services}
            setServices={(val) => {
              const valInt = parseInt(val, 10)
              setServices(services.map((value) => {
                if (
                  (value.id === 1 && _.includes([1, 2], valInt))
                  || (value.id === 2 && valInt === 3)
                  || (value.id === 3 && valInt === 4)
                  || (value.id === 4 && valInt === 5)
                  || (value.id === 5 && valInt === 6)
                  || (value.id === 6 && valInt === 7)
                  || (value.id === 6 && valInt === 8)
                  || (value.id === 6 && valInt === 9)
                ) {
                  const dataSelectedService = _.filter(v.services, d => d.id === valInt)
                  return { ...value, checked: valInt, data: dataSelectedService[0] }
                  // return { ...value, checked: valInt }
                }
                return value
              }))
            }}
          />
        ))
      }}
      </Query>
    </Template>
)

// const Step3 = ({
//   nextStep, backStep, additionalServices, setAdditionalServices, location,
// }) => {
//   const mappedAdditional = location === 1 ? _.drop(additional) : additional
//   return (
//     <Template
//       title='Select Additional Services'
//       buttonProps={{
//         next: {
//           text: 'Next to select staff',
//           onClick: () => nextStep(),
//         },
//         back: {
//           text: 'Go back',
//           onClick: () => backStep(),
//         },
//       }}
//     >
//     {
//       mappedAdditional.map(v => (
//         <AdditionalServiceCategory
//           data={v}
//           key={v.id}
//           additionalServices={location === 1 ? _.drop(additionalServices) : additionalServices}
//           setAdditionalServices={(val) => {
//             const valInt = parseInt(val, 10)
//             setAdditionalServices(additionalServices.map((value) => {
//               if (value.id === 0 && _.includes([0, 1, 2], valInt)) {
//                 return { ...value, checked: valInt }
//               } if (value.id === 1 && _.includes(['3', null], val)) return { ...value, checked: _.isNull(val) ? null : 3 }
//               return value
//             }))
//           }}
//         />
//       ))
//     }
//     </Template>
//   )
// }

const Step4 = ({
  nextStep, backStep, setStaff, staff, filterData,
}) => (
  <Template
    title='Select Staff'
    buttonProps={{
      next: {
        text: 'Next to select time',
        onClick: () => nextStep(),
        disabled: staff === null,
      },
      back: {
        text: 'Go back',
        onClick: () => backStep(),
      },
    }}
  >
    <Query
      query={GET_BARBERS}
      fetchPolicy='cache-and-network'
      variables={{
        shopId: filterData.shopId,
        serviceId: filterData.serviceId,
      }}
    >
    {
      ({ loading, data, error }) => {
        if (error) return <TextWithIcon icon='fal fa-bomb' text='Something went wrong' />
        if (loading || !data) return <Loading width='100%' center={true} />
        if (data.barbers.lists.length <= 0) return <TextWithIcon icon='fal fa-cut' text='No Barber available on this service and branch' />
        const radioList = data.barbers.lists.length > 0 && data.barbers.lists.map(v => (
          {
            radioId: v.barberName,
            text: v.barberName,
            label: v.description,
            value: v.id,
            img: v.barberImage ? v.barberImage : 'http://i.pravatar.cc/300?img=12',
            checked: staff && parseInt(staff.value, 10) === v.id,
          }
        ))
        radioList.unshift(
          {
            radioId: 'noPref',
            text: noPreference.text,
            label: noPreference.label,
            value: noPreference.id,
            img: noPreference.img,
            checked: staff && parseInt(staff.value, 10) === noPreference.id,
          },
        )
        return (
          <RadioGroup
          RadioGroupMargin='-16px 0 0'
          radioName='location'
          value={radioList}
          onChange={(value) => {
            const selectedStaff = _.filter(radioList, v => v.value === parseInt(value, 10))
            if (selectedStaff.length > 0) {
              setStaff(selectedStaff[0])
            }
          }}
        />
        )
      }
    }
    </Query>
  </Template>
)

const WeekCalendar = ({
  selectedDate, selectedTime, setSelectedDate, selectTime, filterData, setIsShowPreference, isShowPreference,
}) => {
  const [startDate, setStartDate] = useState(moment.tz('Asia/Bangkok').subtract(1, 'days').format('DD MMM YYYY'))
  const [dateList, setDateList] = useState([])
  const [endDate, setEndDate] = useState(moment.tz('Asia/Bangkok').format('DD MMM YYYY'))
  const [disblePrev, setDisablePrev] = useState(true)
  const changeDate = (type) => {
    const days = []
    if (type === 'next') {
      for (let i = 1; i <= 7; i += 1) {
        days.push(moment.tz(startDate, 'Asia/Bangkok').add(i, 'days').format('DD MMM YYYY'))
      }
      setDisablePrev(false)
    } else {
      for (let i = 7; i >= 1; i -= 1) {
        const date = moment.tz(endDate, 'Asia/Bangkok').subtract(i, 'days').format('DD MMM YYYY')
        if (moment.tz('Asia/Bangkok').diff(date, 'days') === 0) {
          setDisablePrev(true)
        }
        days.push(date)
      }
    }
    setDateList(days)
    setStartDate(days[days.length - 1])
    setEndDate(days[0])
    const selectedDateMoment = moment.tz(selectedDate, 'Asia/Bangkok').format('DD MMM YYYY')
    if (moment.tz(selectedDateMoment, 'Asia/Bangkok').isSame(moment.tz(startDate, 'Asia/Bangkok').format('DD MMM YYYY'))) {
      setSelectedDate(days[0])
    }
  }
  useEffect(() => {
    changeDate('next')
    setDisablePrev(true)
  }, [])

  return (
    <Div>
      <Div style={{ borderBottom: `1px solid ${theme.color.paleGrey}` }} padding='0 0 24px'>
        <Div margin='0 0 16px' display='flex' justifyContent='space-between'>
          <Icon
            style={{ cursor: disblePrev ? 'not-allowed' : 'pointer' }}
            color={disblePrev ? theme.color.silver : theme.color.black}
            icon='fas fa-chevron-left'
            onClick={() => !disblePrev && changeDate('prev')}
          />
          <P bold={true}>{moment.tz(endDate, 'Asia/Bangkok').format('MMMM')}</P>
          <Icon
            style={{ cursor: 'pointer' }}
            color={theme.color.black}
            icon='fas fa-chevron-right'
            onClick={() => changeDate('next')}
          />
        </Div>
        <Div style={{ cursor: 'pointer' }} display='flex' justifyContent='space-between'>
        {
          dateList.map((v, index) => (
            <Div textAlign='center' key={index} onClick={() => setSelectedDate(v)}>
              <Label>{moment.tz(v, 'Asia/Bangkok').format('ddd')}</Label>
              <P color={moment.tz(v, 'Asia/Bangkok').isSame(moment.tz(selectedDate, 'Asia/Bangkok')) && theme.color.primaryColor} display="block" bold={true}>{moment.tz(v, 'Asia/Bangkok').format('DD')}</P>
            </Div>
          ))
        }
        </Div>
      </Div>
      <Query
        query={GET_APPOINMENT}
        fetchPolicy='cache-and-network'
        variables={{
          shopId: parseInt(filterData.shopId, 10),
          serviceId: filterData.serviceId,
          barberId: parseInt(filterData.staff, 10) === noPreference.id ? null : parseInt(filterData.staff, 10),
          date: selectedDate,
        }}
      >
      {
        ({ loading, data }) => {
          if (loading || !data) {
            return (
              <Div margin='96px 0' textAlign='center'>
                <Loading vertical text='loading' />
              </Div>
            )
          }

          const {
            appointments: {
              isSuccess,
              message,
            },
          } = data
          const allList = data.appointments.data.lists
          const availableTimeList = allList && allList.length > 0 ? _.filter(allList, v => moment.tz('Asia/Bangkok').diff(moment.tz(v.start, 'Asia/Bangkok'), 'minutes') <= 0 && v
            && ((v.isSuccess === false && v.appointment && v.appointment.isPreference) || v.isSuccess))
            : []

          const timeList = availableTimeList.length > 0 ? availableTimeList.map(v => ({
            time: moment.tz(v.start, 'Asia/Bangkok').format('HH:mm'),
            timeString: moment.tz(v.start, 'Asia/Bangkok').format('HH:mm'),
            isPreference: v.appointment.isPreference,
          })) : []
          const isPreference = (allList.filter(v => v.appointment && v.appointment.isPreference)).length > 0
          const notWorking = parseNotWorkingTodayMessage(message)
          if (timeList.length <= 0 && isSuccess === false && notWorking) {
            // Always offer selected-shop contact (day-off / other-branch)
            setIsShowPreference(false)
            if (notWorking.type === 'at') {
              const branchName = notWorking.shopname
              return (
                <Div margin='96px 0' textAlign='center'>
                  <P textAlign='center' light={true} color={theme.color.heather}>This barber is working at {branchName} location today.</P><br/>
                  <P margin='8px 0 0' light={true} color={theme.color.heather}>If you’d like to book with them today, please go back to the main menu and select {branchName} Branch.</P>
                  <SelectedShopContactLine shopId={filterData.shopId} />
                </Div>
              )
            }
            return (
              <Div margin='96px 0' textAlign='center'>
                <P textAlign='center' light={true} color={theme.color.heather}>This barber is not working today.</P><br/>
                <P margin='8px 0 0' light={true} color={theme.color.heather}>Sorry for any inconvenience.</P>
                <SelectedShopContactLine shopId={filterData.shopId} />
              </Div>
            )
          }
          if (timeList.length <= 0) {
            // No bookable timeslots: still offer shop contact so customer can call to book
            setIsShowPreference(true)
            return (
              <Div margin='96px 0' textAlign='center'>
                {isPreference ? (
                  <React.Fragment>
                    <P textAlign='center' light={true} color={theme.color.heather}>No online booking slots are left for this barber today.</P><br/>
                    <P margin='8px 0 0' light={true} color={theme.color.heather}>Some times may be held for preference customers — please contact the shop below if you need to book.</P>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <P textAlign='center' light={true} color={theme.color.heather}>My apologies to you all, we are already fully booked today.</P><br/>
                    <P margin='8px 0 0' light={true} color={theme.color.heather}>Sorry for any inconvenience. Please contact the shop below if you still need a booking.</P>
                  </React.Fragment>
                )}
              </Div>
            )
          }
          setIsShowPreference(isPreference)
          const currentDate = moment.tz(availableTimeList[0].start, 'Asia/Bangkok').format('DD MMM YYYY')
          const selectedDateMoment = moment.tz(selectedDate, 'Asia/Bangkok').format('DD MMM YYYY')
          return (
            <TimeBox
              list={timeList}
              onChange={time => selectTime(time)}
              radioName='time'
              isSelectDate={availableTimeList.length > 0 && moment.tz(selectedDateMoment, 'Asia/Bangkok').isSame(moment.tz(currentDate, 'Asia/Bangkok'))}
              selectedTime={selectedTime}
            />
          )
        }
      }
      </Query>
    </Div>
  )
}

const TimeRadio = ({
  value, radioId, radioName, onChange, checked, isPreference, text,
}) => {
  if (isPreference) {
    return (
      <DisabledTimeWrapper>
        <RadioInput
          value={value}
          type='radio'
          id={radioId}
          name={radioName}
          // onChange={e => onChange(e.target.value)}
          // onClick={e => isCheckbox && onRemove(e.target.value)}
          checked={checked}
        />
        <TimeLabel htmlFor={radioId}>
          <P light={true}>{text}
            <TimeError color="error" > * </TimeError>
          </P>
          <Icon icon='far fa-check' />
        </TimeLabel>
      </DisabledTimeWrapper>
    )
  }
  return (
    <TimeWrapper>
      <RadioInput
        value={value}
        type='radio'
        id={radioId}
        name={radioName}
        onChange={e => onChange(e.target.value)}
        // onClick={e => isCheckbox && onRemove(e.target.value)}
        checked={checked}
      />
      <TimeLabel htmlFor={radioId}>
        <P light={true}>{text}</P>
        <Icon icon='far fa-check' />
      </TimeLabel>
    </TimeWrapper>
  )
}

const TimeBox = ({
  list, onChange, radioName, selectedTime, isSelectDate,
}) => (
  <TimeListWrapper>
  {
    list.length > 0 && list.map(v => (
      <TimeRadio
        radioName={radioName}
        onChange={val => onChange(val)}
        key={v.time}
        value={v.time}
        text={v.timeString}
        radioId={v.time}
        checked={isSelectDate && selectedTime === v.time}
        isPreference={v.isPreference}
      />
    ))
  }
  </TimeListWrapper>
)

const Step5 = ({
  nextStep, backStep, filterData, selectedDate, setSelectedDate, selectedTime, setSelectedTime,
  isShowPreference, setIsShowPreference,
}) => (
  <Template
    title='Select Time'
    subtitle='it’s normally a one-hour session for each customer.'
    buttonProps={{
      next: {
        text: 'Book now',
        onClick: () => nextStep(),
        disabled: selectedTime === null,
      },
      back: {
        text: 'Go back',
        onClick: () => backStep(),
      },
    }}
  >
    <WeekCalendar
      selectedDate={selectedDate}
      selectedTime={selectedTime}
      setSelectedDate={value => setSelectedDate(value)}
      selectTime={time => setSelectedTime(time)}
      filterData={filterData}
      isShowPreference={isShowPreference}
      setIsShowPreference={val => setIsShowPreference(val)}
    />
    {
      isShowPreference
        ? <ErrorIspreferenceMessage > * Please contact admin to make a booking  at this timeslot {
          (() => {
            const contact = getShopContact(filterData && filterData.shopId)
            if (contact && contact.displayPhone && contact.tel) {
              return <a href={`tel:${contact.tel}`}>{contact.displayPhone}</a>
            }
            if (contact) {
              return <span>{contact.name} branch</span>
            }
            return null
          })()
           }
          </ErrorIspreferenceMessage>
        : ''
    }
  </Template>
)

const TextWithLabel = ({ title, data, margin }) => (
  <Div margin={margin}>
    <Label margin='0 0 4px'>{title}</Label>
    <P display="block">{data}</P>
  </Div>
)

const Step7 = ({
  backStep, filterData, registerData, onCreateAppointment,
}) => {
  const [disabledButton, setDisabledButton] = useState(false)
  const [loadingState, setLoadingState] = useState(false)
  const displayDate = moment.tz(`${filterData.selectedDate} ${filterData.selectedTime}`, 'DD MMM YYYY HH:mm', 'Asia/Bangkok')
  return (
    <Mutation
      mutation={CREATE_APPOINTMENT}
    >
    {
      doCreateAppointment => (
        <Template
          confirm
          title='Confirm Booking'
          buttonProps={{
            next: {
              text: 'Confirm',
              onClick: () => {
                setDisabledButton(true)
                setLoadingState(true)
                doCreateAppointment({
                  variables: {
                    barberId: parseInt(filterData.staff.value, 10) === noPreference.id ? null : parseInt(filterData.staff.value, 10),
                    shopId: filterData.shop.value,
                    serviceId: _.filter(filterData.serviceDetail, v => v.checked !== null).length > 0 ? _.filter(filterData.serviceDetail, v => v.checked !== null).map(v => v.checked) : [],
                    start: displayDate,
                    noPreference: filterData.staff.text === 'No Preference',
                  },
                }).then(({ data }) => {
                  if (onCreateAppointment) {
                    setTimeout(() => {
                      onCreateAppointment(data.createAppointment)
                    }, 2000)
                  }
                })
              },
              loading: loadingState,
              disabled: disabledButton,
            },
            back: {
              text: 'Go back',
              onClick: () => backStep(),
            },
          }}
        >
          <TextWithLabel title='Date' data={displayDate.format('ddd DD MMMM YYYY, HH:mm')} />
          <ConfirmDataSpaceBetweenWrapper>
            <Div margin='0 120px 0 0'>
              <Label margin='0 0 4px'>Selected Services</Label>
              {
                filterData.serviceDetail.map((v, index) => (
                  <P
                    margin={index !== 0 && '4px 0 0'}
                    key={index}
                    display="block"
                  >{v.data.serviceName}({v.data.time} mins) - {v.data.price} Baht</P>
                ))
              }
            </Div>
            <Div>
              <Label margin='0 0 4px'>Selected Barber</Label>
              <Div display='flex'>
                <BarberImg img={filterData.staff.img} />
                <P margin='0 0 0 8px'>{filterData.staff.text}</P>
              </Div>
            </Div>
          </ConfirmDataSpaceBetweenWrapper>
          <TextWithLabel title='Location' data={filterData.shop.text} />
          <DividerConfirm margin='32px 0' />
          {
            registerData && Object.keys(registerData).length > 0
              ? <Div>
                <TextWithLabel title='Your Name' data={registerData.firstname} />
                <TextWithLabel margin='24px 0 0' title='Phone' data={registerData.phonenumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')} />
              </Div>
              : <Query
                query={GET_ME}
              >
              {
                ({ loading, data }) => {
                  if (loading || !data) return <p>loading</p>
                  return (
                    <Div>
                      <TextWithLabel title='Your Name' data={data.me.firstname} />
                      <TextWithLabel margin='24px 0 0' title='Phone' data={data.me.phonenumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')} />
                    </Div>
                  )
                }
              }
              </Query>
          }
        </Template>
      )
    }
    </Mutation>
  )
}

const BookingStatusContainer = ({
  status, icon, text, color,
}) => (
  <BookingStatusWrapper>
    {
      <StatusWrapper>
        <StatusIcon
          color={color}
          icon={icon}
          style={{ fontSize: '32px' }}
        />
        <StatusText
          color={color}
          margin='8px 0 16px'
        >
        {
          status === 'Success' ? 'Thank you for booking with us' : status
        }
        </StatusText>
      </StatusWrapper>
    }
    {
      status === 'Success'
        ? <Div margin='16px 0 0'>
          <P display='block' color={theme.color.error} margin='0 0 16px'>
            <Icon fontSize='16px' icon='fal fa-exclamation-circle' color={theme.color.error} margin='0 8px 0 0'/>Please be kindly reminded that
          </P>
          <P display='block' color={theme.color.error} margin='0 0 8px' light={true}>1. In case of cancellation, please let us know at least 3 hours in advance.</P>
          <P display='block' color={theme.color.error} light={true}>2. Please make sure you are here on time. More than 20 minutes late could result in cancellation or no hair wash.</P>
        </Div>
        : <P light={true}>{text}</P>
    }
  </BookingStatusWrapper>
)

const Step8 = ({ nextStep, backStep, status }) => (
  <Template
    buttonProps={status ? {
      back: {
        text: 'Book more services',
        // onClick: () => backStep(),
        onClick: () => { window.location = '/' },
      },
      next: {
        text: 'See booking detail',
        onClick: () => nextStep(),
      },
    } : {
      back: {
        text: 'Try booking again',
        onClick: () => backStep(),
      },
    }}
  >
  {
    status
      ? <BookingStatusContainer
        status='Success'
        icon='fal fa-check-circle'
        color={theme.color.success}
      />
      : <BookingStatusContainer
        status='Failed'
        icon='fal fa-times-circle'
        text='Something went wrong'
        color={theme.color.error}
      />
  }
  </Template>
)

const ReserveStep = (props) => {
  const [step, setStep] = useState(props.location.state ? props.location.state.step : 1)
  const [location, setLocation] = useState(props.location.state ? props.location.state.filterData.shop : null)
  const [staff, setStaff] = useState(props.location.state ? props.location.state.filterData.staff : null)
  const [services, setServices] = useState(props.location.state ? props.location.state.filterData.serviceDetail : [
    {
      id: 1,
      checked: null,
    }, {
      id: 2,
      checked: null,
    }, {
      id: 3,
      checked: null,
    }, {
      id: 4,
      checked: null,
    }, {
      id: 5,
      checked: null,
    }, {
      id: 6,
      checked: null,
    },
  ])
  const [additionalServices, setAdditionalServices] = useState([
    {
      id: 0,
      checked: null,
    }, {
      id: 1,
      checked: null,
    },
  ])
  const [selectedDate, setSelectedDate] = useState(props.location.state ? props.location.state.filterData.selectedDate : moment.tz('Asia/Bangkok').format('DD MMM YYYY'))
  const [selectedTime, setSelectedTime] = useState(props.location.state ? props.location.state.filterData.selectedTime : null)
  const [registerData, setRegisterData] = useState({})

  if (props.history.action === 'REPLACE') {
    window.location.reload()
  }

  return (
    <Div>
      {
        stepSelector(
          step, location, setLocation, setStep,
          setServices, services,
          staff, setStaff,
          additionalServices, setAdditionalServices,
          selectedDate, setSelectedDate,
          selectedTime, setSelectedTime,
          registerData, setRegisterData,
        )
      }
    </Div>
  )
}

export default ReserveStep



// WEBPACK FOOTER //
// ./src/pages/reserve/index.jsx